<template>
  <v-app>
    <v-alert
      v-if="$store.state.configError"
      :value="true"
      type="error"
      class="ma-3">
      {{ $store.state.configError }}
    </v-alert>

    <core-toolbar v-if="showDashboardChrome" />

    <core-drawer v-if="showDashboardChrome" />

    <core-view v-if="!$route.meta.standalone" />
    <router-view v-else />
  </v-app>
</template>

<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>

<script>
export default {
  computed: {
    isSharedRoute () {
      return this.$route.meta.isShared === true
    },

    showDashboardChrome () {
      return !!this.$route.name && !this.isSharedRoute && !this.$route.meta.standalone && ['Welcome', 'Login'].indexOf(this.$route.name) === -1
    }
  }
}
</script>
